import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  flexDisplay: {
    display: 'flex',
  },
  grow: {
    flexGrow: 1,
  },
  itemContainer: {
    padding: '8px',
    flexGrow: 1,
    minHeight: '100px',
  },
  courseListContainer: {
    margin: theme.spacing(1),
    border: '1px solid lightgrey',
    borderRadius: '2px',
    minWidth: '250px',
    overflowX: 'hidden',
    overFlowY: 'auto',
    maxHeight: '300px',
    display: 'flex',
    flexDirection: 'column',
  },
  courseListTitle: {
    padding: theme.spacing(1),
    alignSelf: 'center',
  },
  courseItem: {
    marginBottom: theme.spacing(1),
    border: '1px solid lightgrey',
    borderRadius: '2px',
    padding: theme.spacing(1),
    backgroundColor: 'white',
  },
  gradeSectionLabel: {
    paddingRight: theme.spacing(1),
    fontSize: '18px',
  },
  gradeGrid: {
    paddingTop: theme.spacing(1),
    flexDirection: 'row',
    height: '120px',
  },
  gradeCheckboxLabel: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    marginRight: theme.spacing(1.25),
  },
  courseSetLabel: {
    paddingRight: theme.spacing(1),
    fontSize: '18px',
  },
  courseSetGridContainer: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  gridColumnContainer: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    flexDirection: 'column',
  },
});
